<template>
	<v-container grid-list-md class="px-0">
		<v-layout row wrap>
			<v-flex
				class="d-flex flex-column"
				xs12
				md3
				v-for="(tenant, index) in tenants"
				:key="index"
			>
				<ReservationTenantCard :tenant="tenant"></ReservationTenantCard>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import ReservationTenantCard from "./ReservationTenantCard.vue";
export default {
	components: {
		ReservationTenantCard,
	},
	props: ["tenants"],
};
</script>
